import React, { useEffect, useState, useRef, useContext } from 'react';
import './NoiseVideoBanner.scss';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Modal, Button } from 'react-bootstrap';
import soundIcon from '../../../../assets/smartxonnect/soundIcon.webp';
import muteIcon from '../../../../assets/smartxonnect/muteIcon.webp';
import NoiseWebWebp from '../../../../assets/noise/noise-details-banner-desktop.webp';
import NoiseMobileWebp from '../../../../assets/noise/noise-details-banner-mobile.webp';
import NoiseRideConnected from '../NoiseRide/NoiseRideConnected';
import { pushToDataLayerEvents } from '../../../../dataLayer.js'; // adjust path as needed
import { LayoutDetailsContext } from '../../../Project/Layouts/LayoutDetailsContext';

const NoiseVideoBanner = (props) => {
  const sliderRef = useRef(null);
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    autoplaySpeed: 3000,
  };
  // Popup state
  const [show, setShow] = useState(false);
  const brandName = useContext(LayoutDetailsContext);

  const handleClick = (event, eventCategory, eventAction, eventLabel, isshow) => {
    setShow(isshow);
    pushToDataLayerEvents({
      event: event,
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      BrandName: 'TVS iQube',
    });
  };
  return (
    <div className="noisevideo-wrapper">
      {/* <h1>home page banner section</h1> */}
      {/* Popup Modal */}
      <Modal
        show={show}
        onHide={() => setShow(false)}
        className="noisebannerctap"
        onClick={() =>
          handleClick('Login_Form', 'Login Form', 'Close Icon', 'Popup-For TVS iQube owners', false)
        }
      >
        <Modal.Header closeButton />
        <NoiseRideConnected />
      </Modal>
      <div className="banner-section noisevideo" ref={sliderRef}>
        <Slider {...settings}>
          <div className="always-connected-slider-card">
            <div className="always-connected-slider-image">
              <div className="buynowbtn-top">
                <Button
                  className="buynowbtn"
                  onClick={() =>
                    handleClick(
                      'Banner_Interaction',
                      'Banner_Interaction',
                      'Buy Now',
                      'The Ride that connects beyond the road',
                      true
                    )
                  }
                >
                  Buy Now
                </Button>
              </div>
              <picture>
                <source
                  media="(max-width: 768px)"
                  srcSet={props?.fields?.BannerMediaMobile?.value?.src}
                />
                <img
                  className="banner-image"
                  src={props?.fields?.BannerMedia?.value?.src}
                  alt="Banner"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
          {/* <div className="always-connected-slider-card">
            <div className="always-connected-slider-image">
              <picture>
                <source media="(max-width: 768px)" srcSet={NoiseMobileWebp} />
                <img className="banner-image" src={NoiseWebWebp} alt="Banner" loading="lazy" />
              </picture>
            </div>
          </div> */}
        </Slider>
      </div>
    </div>
  );
};

export default React.memo(NoiseVideoBanner);
